import { Avatar } from "@mui/material";

interface Props {
    src?: string;
    alt?: string;
    size?: number;
}

const UserAvatar = ({ src, alt, size = 40 }: Props) => {
    return (
        <Avatar
            alt={alt}
            src={src}
            sx={{ width: size, height: size }}
        />
    );
};

export default UserAvatar;
